function CoordinatorLogin() {
    window.location.replace(process.env.REACT_APP_COGNITO_COORDINATOR_SIGNIN);
  }
  
  function CoordinatorSignup() {
    window.location.replace(process.env.REACT_APP_COGNITO_COORDINATOR_SIGNUP);
  }
  
  export { CoordinatorLogin, CoordinatorSignup };
  